/* eslint-disable */

(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
    (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
})(window,document,'script','//www.google-analytics.com/analytics.js','ga');

window.crl8.sessionPromise.then(function(session) {
    ga('create', session.gaId, 'curalate.com',);
});

window.crl8.userSessionPromise.then(function(session) {
    // GA officially supports userId, so set that dimension
    // on top of our custom dimensions
    ga('set', 'userId', session.user.id);

    ga('set', 'dimension1', session.group.id);
    ga('set', 'dimension2', session.group.name);
    ga('set', 'dimension3', session.client.id);
    ga('set', 'dimension4', session.client.name);
    ga('set', 'dimension5', session.user.id);
    ga('set', 'dimension6', session.internalInfo.isCuralateEmployee.toString());

    if (session.client.contractStartDate) {
        ga('set', 'dimension7', session.client.contractStartDate);
    }
    if (session.client.contractEndDate) {
        ga('set', 'dimension8', session.client.contractEndDate);
    }
    if (session.client.contractMRR) {
        ga('set', 'dimension9', session.client.contractMRR);
    }
}).always(function() {
    ga('send', 'pageview');
});
